

@if (!loading && AttentionCount?.length) {
  <div  class="add-finacial-body">
    <div class="upper-section"  >
      <div>
        <p class="attibute-title"  >
          The file has {{AttentionCount?.length}} {{AttentionCount?.length  ==1 ? 'reminder' : 'reminders'}} that needs attention
        </p>
      </div>
    </div>
  </div>
}
@if (loading) {
  <div   class="placeholder-body" >
    <div >
      <div class="flex loader-body" >
          <div class="ph-item width-100per loader-body-item" style="padding: 0px;
          margin: 0px;
          border: 0px;">
          <div class="ph-col-12" style="padding: 0px !important">
            <div class="ph-row">
              <div class="ph-col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}



